module.exports = __webpack_public_path__ + "img/user-solid.d6c02352.svg";